import {useNavigate} from 'react-router-dom';
import React, {ReactNode} from 'react';
import {observer} from 'mobx-react';
import Variable from '../../../lib/metadata';
import Button from '../../../components/button';
import PageMenu from '../../../components/page-menu';
import {QueryTableVis} from '../../../insight-container/query-table';
import auth from '../../../lib/auth';
import Alert from '../../../components/alert';

type Props = {
    back: boolean,
    title?: string,
    children?: ReactNode | Array<ReactNode>
}

export function hideKeys(v: Variable) {
    const name = v.name.toLowerCase();
    return !(name === 'year_key' || name === 'year_month_key' || name.endsWith('_dim_key') || name.endsWith('_fact_key') || !v.getTag('Recommended'));
}

const DataExplorer = observer((props: Props) => {
    const {back, title, children} = props;
    const navigate = useNavigate();
    const preContent = children && (children instanceof Array ? children[0] : children);
    const postContent = children && children instanceof Array && children.slice(1);

    return <div>
        <PageMenu>
            {back && <Button color="link" onClick={() => navigate(-1)}><i className="icon-left" /> Back</Button>}
            <div className="flex-grow" />

            <div className="center">
                <h1>{title || 'Data Explorer'}</h1>
            </div>
        </PageMenu>

        {auth.principal?.throttleLimit && <div className="container mt-5">
            <Alert color="orange" icon="icon-warning">
                <strong>Warning</strong> You are using a throttled demo account. That means that all data queries will
                show adjusted and limited results. Specifically you cannot adjust pagination or apply certain numerical
                filters.
            </Alert>
        </div>}
        {preContent}
        <div className="mt-5 mx-10">
            <QueryTableVis />
        </div>
        {postContent}
    </div>;
});

export default DataExplorer;